// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3iHkI","footer":"ModalCreateQualiphyProcedure_footer__3C2KK","additionData":"ModalCreateQualiphyProcedure_additionData__GJVR6"};